import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27a43174"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Admin", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_MenuAdmin = _resolveComponent("MenuAdmin")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_HeaderAdmin = _resolveComponent("HeaderAdmin")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_loading = _resolveComponent("loading")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, {
    id: "components-layout-demo-custom-trigger",
    class: "site-layout"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_sider, {
        collapsed: _ctx.collapsed,
        trigger: null,
        collapsible: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_BaseIcon, {
              name: "logo",
              size: 48
            }),
            _hoisted_2
          ]),
          _createVNode(_component_MenuAdmin)
        ]),
        _: 1
      }, 8, ["collapsed"]),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_HeaderAdmin, {
                value: _ctx.collapsed,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.collapsed) = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, { class: "container" }, {
            default: _withCtx(() => [
              (_ctx.backLink)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "back-link",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
                  }, _toDisplayString('< ' + _ctx.$t('common.back')), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_loading, null, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}